<template>
  <div class="signInSuccessDiv" v-if="showContent">
    <div class="logo">
      <img src="../assets/img/successful_icon.png" alt="" width="48%" />
      <div class="desc1">报到成功</div>
      <div class="desc2">
        您已经报到成功，<br />请按照安保人员指示有序进厂。
      </div>
    </div>
    <div class="divide">
      <div class="divide-line"></div>
      报到后可使用
    </div>
    <noticeList :bg="bg" btnText="进入" @viewDetail="viewDetail"></noticeList>
    <div class="btn">
      <van-button
        type="primary"
        block
        style="font-size: 18px;margin: 14px 0px;"
        @click="
          $router.push({
            path: '/rhwxSignIn',
            query: {
              map_type: $route.query.map_type,
              com_id: $route.query.com_id,
              sub_com_id: $route.query.sub_com_id
            }
          })
        "
        >返回首页</van-button
      >
      <!-- <van-button
        block
        style="font-size: 18px;color: #009967;background-color: #E2E3E4;"
        @click="window.opener = null"
        >关闭</van-button
      > -->
    </div>
  </div>
</template>

<script>
import noticeList from "@/components/noticeList";
export default {
  components: {
    noticeList
  },
  data() {
    return {
      tag: false,
      bg: [
        {
          img: require("../assets/img/route_bg.png"),
          title: "查看厂区平面图",
          color1: "#62E9C5",
          color2: "#3BC69E",
          route: "/rhwxRouteGuide",
          query: {
            map_type: "ht"
          }
        },
        {
          img: require("../assets/img/line_up_bg.png"),
          title: "查看当前排队情况",
          color1: "#AEBCE9",
          color2: "#79A1DA",
          route: "/rhwxQueueBoard",
          query: {}
        },
        {
          img: require("../assets/img/car_bg.png"),
          title: "阅读安全告知书",
          color1: "#FEC375",
          color2: "#F28E1E",
          route: "/rhwxNotice",
          query: {
            type: "success",
            map_type: "ht"
          }
        }
      ],
      rowDataObj: {},
      showContent: false
    };
  },
  created() {},
  mounted() {
    // 提交报到信息
    this.submitCheckIn();
    this.getDetail();
  },
  methods: {
    viewDetail(route) {
      if (route) {
        if (route === "/rhwxQueueBoard") {
          // 当前无排队信息时，禁止司机查看
          if (
            Number(this.rowDataObj.report.is_input_queue) === 0 ||
            this.rowDataObj.business.length === 0
          ) {
            this.$common.mbToastFail("当前账号无排队信息");
            return false;
          } else if (Number(this.rowDataObj.report.booking_state) === 8) {
            this.$common.mbToastFail("车辆已离厂");
            return false;
          } else {
            this.$router.push({
              path: route,
              query: {
                map_type: this.$route.query.map_type,
                com_id: this.$route.query.com_id,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          }
        } else if (route === "/rhwxNotice") {
          if (this.rowDataObj.safetyNotice.length === 0) {
            this.$common.mbToastFail("当前无排队安全告知书信息");
            return false;
          } else {
            this.$router.push({
              path: route,
              query: {
                type: "success",
                map_type: this.$route.query.map_type,
                com_id: this.$route.query.com_id,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          }
        } else {
          this.$router.push({
            path: route,
            query: {
              map_type: this.$route.query.map_type,
              com_id: this.$route.query.com_id,
              sub_com_id: this.$route.query.sub_com_id
            }
          });
        }
      }
    },

    // 获取报到详情
    getDetail() {
      this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          // 1 立即报到  2 再次报到-已有业务  3 再次报到-正常报到  4-重新报到
          this.rowDataObj = res.data.data;
        });
    },

    // 提交报到信息
    submitCheckIn() {
      let data = JSON.parse(localStorage.getItem("submitCheckIn"));
      if (data !== "undefined") {
        this.$common
          .http({
            url: "/api/queue/driver/submit_report",
            data: data
          })
          .then(res => {
            console.log(res);
            if (res.data.data) {
              this.showContent = true;
              localStorage.removeItem("submitCheckIn");
            }
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.signInSuccessDiv {
  padding: 0px 16px;
  .logo {
    text-align: center;
    padding: 26px 27px 36px;
  }
  .desc1 {
    font-size: 20px;
    color: #009967;
    margin-top: 10px;
  }
  .desc2 {
    font-size: 16px;
    color: #999;
    margin-top: 10px;
  }
  .btn {
    padding: 22px 0px 15px;
  }
  .divide {
    font-size: 16px;
    opacity: 0.8;
    &-line {
      height: 16px;
      width: 4px;
      background: #009967;
      display: inline-block;
      vertical-align: text-top;
    }
  }
}
</style>
